// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentInterface } from '../app/_shared/interfaces/environment.interface';

export const environment: EnvironmentInterface = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCIB9urP8dH5QCjrIo8c5d6gOyS7bauf4Y",
    authDomain: "blush-dev-425512.firebaseapp.com",
    projectId: "blush-dev-425512",
    storageBucket: "blush-dev-425512.appspot.com",
    messagingSenderId: "785880765805",
    appId: "1:785880765805:web:268822b588bdcfb8ebf664",
    measurementId: "G-B05C5CM472",
    databaseURL:"https://blush-dev-425512-default-rtdb.firebaseio.com"
  },
  // apiUrl: 'http://localhost:5000/blush-dev-425512/us-central1',
  apiUrl: 'https://us-central1-blush-dev-425512.cloudfunctions.net',
  apiPosUrl: 'https://us-central1-blush-dev-425512.cloudfunctions.net',
  mapsApiKey: 'AIzaSyBs4kc0MSe-kxU8w2lrDfhauw2Xfq_yqKc',
  baseUrl: 'https://cms.dev.blushco.io',
  release: '00.01',
  envName: 'DEV',
  hoodieAPIkey: '64b0137687c0842a46a7a150ddafb443',
  searchAPIkey: '',
  makioUrl: 'https://makio-dev.leafvip.app',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
